import React, { useEffect } from 'react';
import { ToastContainer } from 'react-toastify';

import {
  NOTIFICATION_TOASTER_OPTIONS,
  POPUP_NOTIFICATIONS_CONTAINER_ID,
} from 'utils/toastUtils';
import { closeAllPopupNotifications } from 'utils/notificationUtils';

export default function PopupNotificationContainer() {
  useEffect(() => {
    return () => {
      closeAllPopupNotifications();
    };
  }, []);

  return (
    <ToastContainer
      enableMultiContainer
      {...NOTIFICATION_TOASTER_OPTIONS}
      containerId={POPUP_NOTIFICATIONS_CONTAINER_ID}
    />
  );
}
